import React from 'react';
import { Link } from 'react-router-dom';
import { useCardLinksStyles } from './CardLinks.styles';
import { Box } from '../../../../../theme/fluent';

export type CardLinksProps = {
  links?: {
    label?: string;
    url?: string;
  }[];
};

const CardLinks: React.FC<CardLinksProps> = ({ links }) => {
  const { classes, linkStyle } = useCardLinksStyles();
  if (!links || links.length === 0) return null;
  return (
    <Box as="div" className={classes.root}>
      {links.map((link) => {
        if (!link?.url || !link?.label) return null;
        return (
          <Link key={link?.url} to={link?.url} title={link.label} className={classes.link} style={linkStyle}>
            {link?.label}
          </Link>
        );
      })}
    </Box>
  );
};

export default CardLinks;
